import React, { FC, useCallback, useContext, useMemo } from 'react'
import styled from 'styled-components'
import { sliderContext } from 'ui/slider'
import { VideoProps } from 'ui/video/types'

export const YoutubeVideo: FC<VideoProps> = ({ link, onApiReady }) => {
  const videoId = useMemo(() => getYoutubeVideoId(link), [link])
  const { isMoving } = useContext(sliderContext)

  const onElementReady = useCallback(
    (element: HTMLIFrameElement) => {
      if (element) {
        const sendCommand = (commandName: string) =>
          element.contentWindow?.postMessage(`{"event":"command","func":"${commandName}","args":""}`, '*')

        const play = () => sendCommand('playVideo')

        const stop = () => sendCommand('stopVideo')

        const pause = () => sendCommand('pauseVideo')

        if (onApiReady)
          onApiReady({
            play,
            pause,
            stop
          })
      }
    },
    [onApiReady]
  )

  return (
    <Iframe
      width="100%"
      height="100%"
      src={`https://www.youtube.com/embed/${videoId}?enablejsapi=1&rel=0&hd=1`}
      title="YouTube video player"
      frameBorder="0"
      allow="autoplay; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      ref={onElementReady}
      isMoving={isMoving}
    />
  )
}

const getYoutubeVideoId = (videoUrl: string): string | undefined => {
  /**
   * Regexp origins:
   * https://stackoverflow.com/a/66405602/5877826
   */

  const match = videoUrl.match(
    /(?:https?:\/\/)?(?:www\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\/?\?v=|\/embed\/|\/)([^\s&]+)/
  )

  if (match && match[1]) return match[1]

  return
}

const Iframe = styled.iframe<{ isMoving: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: ${({ isMoving }) => (isMoving ? 'none' : 'all')};
`
